import mutations from '@/modules/questionnaire/store/mutations';
import actions from '@/modules/questionnaire/store/actions';
import getters from '@/modules/questionnaire/store/getters';

import { getInitialState } from '@/modules/questionnaire/store/state';

const state = getInitialState();

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
